import { DataTypeConfig } from "../../../../types";

export const systemTypesConfig: DataTypeConfig = {
  tabs: [], // No tabs specified for System Types
  searchableColumns: [
    "System Type Name",
    "Description",
    "Parameter Name",
    "Unit of Measurement",
    "Parameter Description",
  ],
  filterColumns: [], // No filters specified for System Types
  tableColumns: [
    { key: "systemTypeName", header: "System Type Name", type: "custom" },
    { key: "description", header: "Description", type: "custom" },
    { key: "parameterName", header: "Parameter Name", type: "custom" },
    { key: "unitOfMeasurement", header: "Unit", type: "custom" },
    {
      key: "parameterDescription",
      header: "Parameter Description",
      type: "custom",
    },
  ],
  mandatoryFields: [
    "System Type Name",
    "Description",
    "Parameter Name",
    "Unit of Measurement",
    "Parameter Description",
  ],
};

export const systemTypesTabDisplayNames: Record<string, string> = {};

export const systemTypesTabDropdownOptions = (tabName: string) => {
  return [];
};
